const getFullName = (item) => {
  if (!item || typeof item !== 'object') {
    return '';
  }
  const firstName = item?.firstName || item?.first_name || '';
  const lastName = item?.lastName || item?.last_name || '';

  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }
  return firstName || lastName;
};

export default getFullName;
